import { render, staticRenderFns } from "./dount-chart.vue?vue&type=template&id=15733d5c&scoped=true&"
import script from "./dount-chart.ts?vue&type=script&lang=ts&"
export * from "./dount-chart.ts?vue&type=script&lang=ts&"
import style0 from "./dount-chart.scss?vue&type=style&index=0&id=15733d5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15733d5c",
  null
  
)

export default component.exports